<template>
    <section class="hero fallback">
        <div class="container">
            <div class="column-wrapper">
                <div class="column content">
                    <h1 class="page-title">404 - something went wrong</h1>
                </div>
            </div>
        </div>
    </section>
    <section class="error 404">
        <div class="container">
            <div class="column-wrapper">
                <div class="column content">
                    <p>
                        The page <strong>{{ getUrlLocation }}</strong> no longer exists or is not found.
                    </p>
                    <p>
                        Click on the following button to return to home.
                    </p>
                    <br>

                    <nav class="error-nav">
                        <ul class="mini-nav">
                            <li><router-link class="button" to="/">Home</router-link></li>
                        </ul>
                    </nav>

                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    computed: {
        getUrlLocation() {
            return window.location.pathname;
        }
    }
};
</script>

<style lang="scss" scoped>
// @import styles
@import './index.scss';
</style>
